import { SearchedKeywordModel } from './searched.keyword.model';

export class PagedSearchedKeywordManageModel {
    currentPage: number;
    totalPages: number;
    pageSize: number;
    totalCount: number;
    items: SearchedKeywordModel[] = [];
}
